import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

const rootElement = document.getElementById('root') as HTMLElement;

if (rootElement.hasChildNodes()) {
  // Hydrate for pre-rendered content
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App/>
    </React.StrictMode>,
    {
      onRecoverableError: (error, errorInfo) => {
        console.error("Hydration mismatch error:", error);
        console.error("Component stack:", errorInfo.componentStack);
      },
    }
  );
} else {
  // Normal render for development
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
